import React, { useState, useEffect } from "react";
import { Table, Button } from "reactstrap";
import NumberFormat from "react-number-format";

import {
	getListOfAuctionCompanies,
	deleteAuctionCompanyById,
} from "api/VendorsAPI";
import {
	retrieveFailAlert,
	confirmDeleteAlert,
	deleteSuccessAlert,
	deleteFailAlert,
} from "utils/alertUtils";
import { showApiError } from "utils/errorRoutingUtils";
import { useFromUser } from "stores/LocalStorageHelper";
import LoadingSpinner from "components/loadingSpinner/LoadingSpinner";
import { PhoneMask } from "../../../forms/components/InputElement";

const AuctionCompaniesTable = ({ refresh, editFields, setRefresh, toggle }) => {
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(true);
	const locationID = useFromUser("locationID");

	useEffect(() => {
		fetchData();
		// eslint-disable-next-line
	}, [refresh]);

	const fetchData = () => {
		getListOfAuctionCompanies(locationID).then(
			(res) => {
				setData(res.data.content);
				setLoading(false);
			},
			(err) => {
				if (!err.isGeneralError) {
					showApiError(err, retrieveFailAlert);
				}
			}
		);
	};

	const removeCompany = (id) => {
		deleteAuctionCompanyById(id).then(
			() => {
				setRefresh(!refresh);
				deleteSuccessAlert();
			},
			() => deleteFailAlert()
		);
	};

	const handleEdit = (company) => {
		editFields.setFields(company);
		toggle();
	};

	const tableData = data.map((company, index) => (
		<tr key={company.id || index}>
			<th scope="row">{index + 1}</th>
			<td>{company.name}</td>
			<td>{company.permitNumber}</td>
			<td>{company.dealerNumber}</td>
			<td>
				<NumberFormat
					value={company.phone1}
					format={PhoneMask()} //"+1 (###) ###-####"
					displayType="text"
				/>
			</td>
			<td>{company.address1}</td>
			<td>{company.address2}</td>
			<td>{company.city}</td>
			<td>{company.state}</td>
			<td>{company.zip}</td>
			<td>
				<Button color="primary" onClick={() => handleEdit(company)}>
					<i className="nc-icon nc-align-center" /> Edit
				</Button>
				<Button
					className="btn-link-danger btn-link text-danger"
					onClick={() => confirmDeleteAlert(removeCompany, company.id)}
				>
					<i className="nc-icon nc-simple-remove" /> Remove
				</Button>
			</td>
		</tr>
	));

	return loading ? (
		<LoadingSpinner />
	) : (
		<div style={{ overflowX: "auto" }}>
			<Table striped hover>
				<thead>
					<tr>
						<th>#</th>
						<th>Name</th>
						<th>Permit #</th>
						<th>Dealer #</th>
						<th>Phone</th>
						<th>Address 1</th>
						<th>Address 2</th>
						<th>City</th>
						<th>State</th>
						<th>Zip</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>{tableData}</tbody>
			</Table>
		</div>
	);
};

export default AuctionCompaniesTable;
